import type { ValidationMessages } from "@/types";

const validationEn: ValidationMessages = {
    'max_length': '{field} must not have more than 0:{max} Element(s) selected',
    'min_length': '{field} must have at least 0:{min} Element(s) selected'
}

export default validationEn
